import { r as registerInstance, c as createEvent, h, g as getElement } from './index-4ec8feae.js';
import { g as generateId, f as focusElement } from './functions-e19590df.js';

const somTextareaCss = "som-textarea .textarea-container{position:relative}som-textarea .textarea-container textarea{padding-bottom:1.5rem}som-textarea .textarea-container .max-nb-chars{position:absolute;right:0.75rem;bottom:0.5rem;text-align:right;font-size:0.6875rem}";

const DEFAULT_ROWS = 3;
let SomTextarea = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.somFocus = createEvent(this, "somFocus", 7);
    this.somInput = createEvent(this, "somInput", 7);
    this.somBlur = createEvent(this, "somBlur", 7);
    this.somChange = createEvent(this, "somChange", 7);
    /**
     * This property can be used to set a label.
     */
    this.label = '';
    /**
     * This property can be used to set a help text.
     */
    this.help = '';
    /**
     * This property can be used to set an error. If a non-empty string is given, it will be used as the error message.
     */
    this.error = null;
    /**
     * This property can be used to set the input as required.
     * Defaults to `false`.
     */
    this.required = false;
    /**
     * This property can be used to set a placeholder text.
     */
    this.placeholder = '';
    /**
     * This property can be used to set the form field name (used when submitting the form).
     */
    this.name = '';
    /**
     * This property can be used to set the textarea value.
     */
    this.value = '';
    /**
     * This property can be used to disable the textarea.
     * Defaults to `false`.
     */
    this.disabled = false;
    /**
     * This property is used to set the textarea as readonly.
     * Defaults to `false`.
     */
    this.readonly = false;
    /**
     * This property is used to set the textarea's number of rows'.
     * Defaults to `3`.
     */
    this.rows = DEFAULT_ROWS;
    /**
     * This property is used to set the textarea's maximum characters limit.
     */
    this.maxLength = null;
    /**
     * This property can be used to set the ARIA label associated with this input (for screen readers).
     */
    this.inputAriaLabel = null;
    this.currentValue = '';
    this.inputId = generateId('som-textarea');
  }
  handleValueChange() {
    this.currentValue = this.value;
  }
  handleRowsChange() {
    if (!this.rows) {
      // Makes sure to always handle the default case
      this.rows = DEFAULT_ROWS;
    }
  }
  /**
   * Public method that sets focus to the textarea element.
   * @returns Promise will resolve after focus.
   */
  setFocus() {
    return focusElement(this.htmlElement);
  }
  handleFocus(e) {
    this.somFocus.emit(e);
  }
  handleInput(e) {
    this.currentValue = e.target.value;
    this.somInput.emit(e);
  }
  handleBlur(e) {
    this.somBlur.emit(e);
  }
  handleChange(e) {
    this.somChange.emit(e);
  }
  isInError() {
    return this.error !== null;
  }
  registerEvents() {
    this.htmlElement.addEventListener('focus', this.handleFocusCb);
    this.htmlElement.addEventListener('input', this.handleInputCb);
    this.htmlElement.addEventListener('blur', this.handleBlurCb);
    this.htmlElement.addEventListener('change', this.handleChangeCb);
  }
  unregisterEvents() {
    this.htmlElement.removeEventListener('focus', this.handleFocusCb);
    this.htmlElement.removeEventListener('input', this.handleInputCb);
    this.htmlElement.removeEventListener('blur', this.handleBlurCb);
    this.htmlElement.removeEventListener('change', this.handleChangeCb);
  }
  componentWillLoad() {
    this.helpElementId = `${this.inputId}-help`;
    this.currentValue = this.value;
    this.handleFocusCb = this.handleFocus.bind(this);
    this.handleInputCb = this.handleInput.bind(this);
    this.handleBlurCb = this.handleBlur.bind(this);
    this.handleChangeCb = this.handleChange.bind(this);
  }
  componentDidLoad() {
    this.htmlElement = this.el.querySelector(`#${this.inputId}`);
    this.registerEvents();
  }
  componentWillUnload() {
    this.unregisterEvents();
  }
  render() {
    const isInError = this.isInError();
    const ariaInvalid = isInError ? { 'aria-invalid': 'true' } : {};
    return (h("som-form-field", { label: this.label, labelFor: this.inputId, help: this.help, helpId: this.helpElementId, required: this.required, error: this.error }, h("div", { slot: "content", class: "textarea-container" }, h("textarea", Object.assign({ id: this.inputId, class: `form-control ${isInError ? 'is-invalid' : ''}`, placeholder: this.placeholder, name: this.name, value: this.currentValue, disabled: this.disabled, readonly: this.readonly, required: this.required, rows: this.rows, maxlength: this.maxLength, "aria-label": this.inputAriaLabel, "aria-describedby": this.helpElementId }, ariaInvalid)), this.maxLength && this.maxLength > 0 ? (h("div", { class: `max-nb-chars ${this.currentValue.length >= this.maxLength ? 'text-danger' : ''}` }, this.currentValue.length, "/", this.maxLength)) : null)));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "value": ["handleValueChange"],
    "rows": ["handleRowsChange"]
  }; }
};
SomTextarea.style = somTextareaCss;

export { SomTextarea as som_textarea };
